import Joi from "joi-browser";

export { schema };

const schema = {
  mcubeApiKey: Joi.string().required().label("API Key"),
  apiBaseUrl: Joi.string().required().label("API Base URL"),
  phoneNumbers: Joi.array()
    .items(
      Joi.string()
        .regex(/^[a-zA-Z0-9+]+$/)
        .required()
        .label("Phone Number")
        .error((errors) => {
          return errors.map((error) => {
            if (error.type === "string.regex.base") {
              return { message: "Phone Number is not valid" };
            }

            if (error.type === "any.empty") {
              return { message: "Phone Number is required" };
            }

            return error;
          });
        }),
    )
    .min(1)
    .required()
    .label("Phone Numbers"),
  audioAcknowledgmentMessage: Joi.string()
    .required()
    .label("Audio Acknowledgement Message"),
  imageAcknowledgmentMessage: Joi.string()
    .required()
    .label("Image Acknowledgement Message"),
  documentAcknowledgmentMessage: Joi.string()
    .required()
    .label("Document Acknowledgement Message"),
};
